export function actorClass(actor) {
    if (!actor)
        return "";
    if (actor.startsWith("human-console:"))
        return "actor--human-console";
    if (actor.startsWith("human-cli:"))
        return "actor--human-cli";
    if (actor.startsWith("agent-cli:"))
        return "actor--agent-cli";
    if (actor === "stub-agent-runner")
        return "actor--stub-agent";
    // Phase 36 Plan 36-D (Rule 1 — auto-fix pre-existing drift caught by new
    // actor-class fence). Engine canonical actor stamp for the Anthropic
    // Claude runner is "agent-runner:claude-sdk-v0" (see
    // platform/workflow-engine/AgentRunner/ClaudeSdkAgentRunner.cs:102 +
    // .planning/milestones/v1.1-MILESTONE-AUDIT.md SC#1 + v1.1-REQUIREMENTS
    // RUN-03). Prior versions of this file claimed `actor === "claude-sdk-runner"`
    // which was a silent typo since v1.2 (d6f4252): the CSS class
    // `actor--claude-sdk` never applied to real agent_decided rows. The new
    // fence test in test/fence/actor-class.fence.test.ts caught it. The fix
    // is to recognise the canonical `agent-runner:` prefix.
    if (actor.startsWith("agent-runner:"))
        return "actor--agent-runner";
    if (actor.startsWith("platform:"))
        return "actor--platform";
    // Phase 36 Plan 36-D (Rule 1 deviation): the engine stamps
    // actor = $"subject:{token_hash_prefix}:{senderHash}" when a public form is
    // submitted (Phase 22 Subject form portal). Phase 444 wave 4 moved that
    // format into its ONE owner, FormTokenValidator.SubjectActor, and replaced
    // the plaintext token with the first 16 chars of its sha256 hash — a live
    // form credential must never land in append-only job_events. Only the
    // MIDDLE segment changed: the branch below still keys on the `subject:`
    // prefix, which did not move. The actor-class fence test
    // (packages/design-system/test/fence/actor-class.fence.test.ts) walks
    // platform/**/*.cs for actor literal emission sites and asserts that
    // every prefix it finds is recognised here. Without this branch the
    // fence would fail on first run against current state — see SUMMARY 36-D.
    if (actor.startsWith("subject:"))
        return "actor--subject";
    if (actor.startsWith("chat:teams:"))
        return "actor--chat-teams";
    // Card #2571 (ADR-121 D9): the guest chat surface's three actor families, all actor class
    // `guest` — `guest:{conversation_id}` (a website visitor), `guest-session:{hash16}` (a visitor
    // refused before a conversation exists) and `guest-link:{link_id}` (a signed link). Like
    // `subject:`, a member of the public, never an operator, so the three share one class. The engine
    // builds them from the consts in platform/core/Chat/GuestChatActors.cs rather than from
    // `actor = "…"` literals; the actor-class fence resolves them from there (PR #2580 review finding 6).
    if (actor.startsWith("guest:"))
        return "actor--guest";
    if (actor.startsWith("guest-session:"))
        return "actor--guest";
    if (actor.startsWith("guest-link:"))
        return "actor--guest";
    return "";
}
//# sourceMappingURL=actorClass.js.map